import * as rewardConst from "./constants";
import transform from "./transform";
import { makeCall } from "@/utils/request";
import { buildOptions, getEndPoints } from "@/utils/api-call";
import { EVENT_TOAST_MESSAGE } from "@/store/events";
import { EventBus } from "@/event-bus";
import messages from "@/locales/index";
import { EVENT_ERROR_TOAST_MESSAGE } from "@/store/events";

export const state = {
  rewards: [],
  rewardCampaigns: [],
  tangoCatalogs: []
};

export const getters = {
  [rewardConst.GETTER_LIST_REWARD]: state => {
    return state.rewards;
  },
  [rewardConst.GETTER_LIST_REWARD_CAMPAIGNS]: state => {
    return state.rewardCampaigns;
  },
  [rewardConst.GETTER_LIST_TANGO_CATALOGS]: state => {
    return state.tangoCatalogs;
  }
};

export const actions = {
  [rewardConst.ACTION_GET_LIST_REWARD]: ({ commit }) => {
    const url = getEndPoints().program_rewards.getList;
    makeCall(url, buildOptions("GET", {}), commit).then(response => {
      if (response && response.data) {
        let transformList = transform.convertListMasterRewardToLevelRewardModel(
          response.data
        );
        commit(rewardConst.MUTATION_SET_LIST_REWARD, transformList);
      }
    });
  },
  [rewardConst.ACTION_GET_LIST_REWARD_CAMPAIGNS]: ({ commit }) => {
    const url = getEndPoints().program_rewards.getListCampaigns;
    makeCall(url, buildOptions("GET", {}), commit).then(response => {
      if (response && response.campaigns) {
        commit(
          rewardConst.MUTATION_SET_LIST_TANGO_CATALOGS,
          response.campaigns
        );
      }
    });
  },
  [rewardConst.ACTION_GET_LIST_TANGO_CATALOGS]: ({ commit }, options) => {
    const url = getEndPoints().program_tango.getTangoCatalogs;
    makeCall(url, buildOptions("GET", {}), commit).then(response => {
      if (response && response.data) {
        commit(rewardConst.MUTATION_SET_LIST_TANGO_CATALOGS, response.data);
        if (options.callback) {
          options.callback(response);
        }
      }
    });
  },
  [rewardConst.ACTIONS_SET_LIST_REWARD_PURE]: ({ commit }, list) => {
    commit(rewardConst.MUTATION_SET_LIST_REWARD, list);
  },
  [rewardConst.ACTION_SET_LEVEL_REWARDS]: ({ commit }, options) => {
    const url = getEndPoints().program_level_rewards.addRewardsToLevel.replace(
      ":id",
      options.programId
    );
    makeCall(url, buildOptions("POST", options.data), commit).then(
      () => {
        EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
        if (options.callback) {
          options.callback();
        }
      },
      error => {
        if (error.response) {
          options.errorHandling();
        }
      }
    );
  },
  [rewardConst.ACTIONS_UPDATE_MILESTONE_REWARDS]: ({ commit }, options) => {
    const url = getEndPoints().program_rewards.updateMilestoneRewards;
    makeCall(url, buildOptions("PUT", options.data), commit)
      .then(response => {
        EventBus.$emit(EVENT_TOAST_MESSAGE, messages.getLocalizedString('changesSavedSuccessfully'));
        if (options.callback) {
          options.callback(response);
        }
      })
      .catch(function(error) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          error.response.data.error.message.message || error
        );
      });
  },
};

export const mutations = {
  [rewardConst.MUTATION_SET_LIST_REWARD]: (state, rewards) => {
    state.rewards = rewards;
  },
  [rewardConst.MUTATION_SET_LIST_REWARD_CAMPAIGNS]: (
    state,
    rewardCampaigns
  ) => {
    state.rewardCampaigns = rewardCampaigns;
  },
  [rewardConst.MUTATION_SET_LIST_TANGO_CATALOGS]: (state, payload) => {
    let tangoCatalogs = [];
    const payloadData = payload;
    [...payloadData].forEach(o => {
      if (o.utid && o.utid !== null) {
        tangoCatalogs.push(o);
      }
    })
    state.tangoCatalogs = tangoCatalogs;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/basic_rewards/index.js